export const errorMessage = {
  EMPTY_FIELD: 'This field must be filled',
  PHONE_ERROR: 'Must be in international format starting with +',
  CONFIRM_PASSWORD: "Passwords don't match",
  FORBIDDEN_COUNTRY: 'Sorry, we don’t offer services in this country',
  RECOMMENDATION_CORPORATE_MAIL: 'We suggest using a corporate email rather than a private one',
}
